import React, { useState, useEffect } from 'react';
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const GrupoDreModal = ({ grupoDre, onClose, onGrupoDreAtualizado }) => {
    const [formData, setFormData] = useState({
        nome: '',
        ordem: '',
        tipo_linha: 'valor',
        operacao: 'soma',
        visivel: true
    });
    const [tituloModal, setTituloModal] = useState("");

    useEffect(() => {
        if (grupoDre != null) {
            setFormData({
                nome: grupoDre.nome || '',
                ordem: grupoDre.ordem || '',
                tipo_linha: grupoDre.tipo_linha || 'valor',
                operacao: grupoDre.operacao || 'soma',
                visivel: grupoDre.visivel !== undefined ? grupoDre.visivel : true
            });
            setTituloModal('Editar Grupo DRE');
        } else {
            setTituloModal('Novo Grupo DRE');
        }
    }, [grupoDre]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nome.trim()) {
            Swal.fire('Atenção', 'O nome do grupo DRE é obrigatório.', 'warning');
            return;
        }

        if (!formData.ordem || formData.ordem < 1) {
            Swal.fire('Atenção', 'A ordem deve ser um número maior que zero.', 'warning');
            return;
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const dataToSend = {
                ...formData,
                ordem: parseInt(formData.ordem)
            };

            if (grupoDre) {
                await api.put(`/grupos-dre/${grupoDre.id}`, dataToSend);
                Swal.fire("Sucesso", "Grupo DRE atualizado com sucesso!", "success");
            } else {
                await api.post('/grupos-dre', dataToSend);
                Swal.fire("Sucesso", "Grupo DRE criado com sucesso!", "success");
            }

            onGrupoDreAtualizado();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response.data.message || 'Erro ao salvar grupo DRE.', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-8">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        maxLength={255}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-md-4 col-12 mt-3 mt-md-0">
                                    <label className="form-label fw-bold">Ordem</label>
                                    <input
                                        type="number"
                                        name="ordem"
                                        className="form-control"
                                        value={formData.ordem}
                                        onChange={handleChange}
                                        min="1"
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            
                            <div className="row mt-3 align-items-end">
                                <div className="col-md-4 col-12">
                                    <label className="form-label fw-bold">Tipo de Linha</label>
                                    <select
                                        name="tipo_linha"
                                        className="form-control"
                                        value={formData.tipo_linha}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="valor">Valor</option>
                                        <option value="subtotal">Subtotal</option>
                                        <option value="total">Total</option>
                                    </select>
                                </div>
                                <div className="col-md-4 col-12 mt-3 mt-md-0">
                                    <label className="form-label fw-bold">Operação</label>
                                    <select
                                        name="operacao"
                                        className="form-control"
                                        value={formData.operacao}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="soma">Soma</option>
                                        <option value="subtrai">Subtrai</option>
                                        <option value="calcula">Calcula</option>
                                    </select>
                                </div>
                                <div className="col-md-4 col-12 mt-3 mt-md-0">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="visivel"
                                            id="visivel"
                                            checked={formData.visivel}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label fw-bold" htmlFor="visivel">
                                            Visível
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer mt-4">
                            <div className="row">
                                <div className="col-12 text-end">
                                    <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                        <FaTimes /> Fechar
                                    </button>
                                    <button className="btn btn-custom-primary ms-3" type="submit">
                                        <FaRegSave /> Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default GrupoDreModal; 